/* eslint-disable */

// Generated by CoffeeScript 2.5.1
(function() {
  //###################
  // File Attachments #
  //###################
  var fSExt, file_display, files, getFileSize, prepareUpload, swal, uploadFiles;

  /*
  How to:
      include attachments.coffee and attachments.css
      in the html:
          make a placeholder area:
              <div class="uploads-section">
                  <div id="<unique_id>" class="uploaded-items">
                  </div>
              </div>

              make a button
              <span type="button" class="file-upload-btn" data-file_placeholder="<SOME ID>">
                  <i class="glyphicon glyphicon-plus add-file-icon"></i>
                  <i class="fa fa-spinner fa-spin loading-item-icon" style="display:none;"></i>
                  &nbsp Add Files...
              </span>
  */
  // Variable to store your files
  swal = require('sweetalert');

  files = void 0;

  window.attachments = {}; // object of attachments

  file_display = {};

  window.current_btn = null;

  fSExt = new Array('Bytes', 'KB', 'MB', 'GB');

  getFileSize = function(fSize) {
    var f_size_string, i;
    i = 0;
    while (fSize > 900) {
      fSize /= 1024;
      i++;
    }
    f_size_string = Math.round(fSize * 100) / 100 + ' ' + fSExt[i];
    if (i > 2) {
      if (i > 2 || Math.round(fSize * 100) / 100 > 25) {
        swal("Files must be less then 25mb");
        f_size_string = "";
      }
    }
    return f_size_string;
  };

  window.getFileSize = getFileSize;

  prepareUpload = function(event) {
    $(".file-upload-btn.current-upload .add-file-icon").css("display", "none");
    $(".file-upload-btn.current-upload .loading-item-icon").css("display", "inline");
    files = event.target.files;
    file_display = {};
    $.each(files, function(key, value) {
      return file_display[value.name] = getFileSize(value.size);
    });
    uploadFiles();
  };

  window.deleteFile = function(event, file_id) {
    `deletes files`;
    var delete_me, e;
    event.preventDefault();
    event.stopPropagation();
    delete_me = "#attachment_" + file_id;
    $(delete_me).remove();
    if (file_id in window.attachments) {
      delete window.attachments[file_id];
    }
    try {
      d3.json(`/outbox/delete/${file_id}/`, function(error, json) {
        console.log(json);
      });
    } catch (error1) {
      // ...
      e = error1;
      console.log(e);
    }
    // updating padding
    if ($("#uploaded-placeholder .file-icon").length === 0) {
      $("#uploaded-placeholder").css("padding-top", "0px");
    }
  };

  // archive <- Add custom font awesome icons
  // audio <- Add custom font awesome icons
  // code <- Add custom font awesome icons
  // excel <- Add custom font awesome icons
  // image <- Add custom font awesome icons
  // movie <- Add custom font awesome icons
  // pdf <- Add custom font awesome icons
  // photo <- Add custom font awesome icons
  // picture <- Add custom font awesome icons
  // powerpoint <- Add custom font awesome icons
  // sound <- Add custom font awesome icons
  // file-video <- Add custom font awesome icons
  // file-word <- Add custom font awesome icons
  // file-zip <- Add custom font awesome icons
  // Catch the form submit and upload the files
  uploadFiles = function() {
    var background_img, data, no_database, secure_upload, url;
    // event.stopPropagation()
    // Stop stuff happening
    // event.preventDefault()
    // Totally stop stuff happening
    // START A LOADING SPINNER HERE

    // check if current button has class no database
    if (window.current_btn.hasClass('no-database')) {
      no_database = true;
    } else {
      no_database = false;
    }
    if (window.current_btn.hasClass('campaign-share-image')) {
      background_img = false;
    } else {
      background_img = true;
    }
    if (window.current_btn.hasClass("secure-file-uploads")) {
      secure_upload = true;
    } else {
      secure_upload = false;
    }
    // Create a formdata object and add the files
    data = new FormData();
    if (!no_database) {
      $.each(files, function(key, value) {
        return data.append(key, value);
      });
      url = '/outbox/attachment/';
    } else {
      console.log('yay here');
      console.log(files[0]);
      data.append('file', files[0]);
      url = '/upload_image/';
    }
    if (secure_upload) {
      url = '/secure_upload/';
    }
    $.ajax({
      url: url,
      type: 'POST',
      data: data,
      cache: false,
      processData: false,
      contentType: false,
      success: function(data, textStatus = "", jqXHR = "") {
        var file_name, file_name_pieces, unique_id;
        if (no_database) {
          console.log("HERE 1");
          if (window.current_btn.hasClass('single-upload')) {
            unique_id = window.current_btn.data('file_placeholder');
            $(`#${unique_id}`).html("");
          }
          file_name_pieces = data.split('__');
          file_name = file_name_pieces[file_name_pieces.length - 1];
          $(`#${current_btn.data('file_placeholder')}`).html(`<div class='file-icon' id='${data}'>
    <div class='outer-icon-container delete-background-img'
        onclick="changed_background_img('', ${background_img}); $(this).parent().parent().find('.fname').html('No Image Selected'); $(this).remove();">
        <div class='delete-icon-container'>
            <i class='delete-icon fa fa-minus-circle fa-sm'></i>
        </div>
    </div>
    <div class="col-sm-3 file-img-container">
        <i class="fa fa-file f-img"></i>
    </div>
    <div class="col-sm-8 file-info-container">
        <div class="fname">${file_name}</div>
    </div>
</div>`);
          // if for action center settings call function to update org design
          if (window.current_btn.hasClass('action-center-settings-file')) {
            window.changed_element(unique_id, data);
          }
          if (window.current_btn.hasClass('campaign-creation-file')) {
            window.changed_background_img(data, background_img);
          }
        } else {
          if (secure_upload) {
            swal("Success", "Your file has been successfully uploaded.", "success");
            $(".file-upload-btn.current-upload .loading-item-icon").css("display", "none");
            return;
          }
          data = JSON.parse(data);
          if (data.error == null) {
            // Success so call function to process the form
            data.map(function(d) {
              // add in padding
              // OUTBOXXXXX
              // if location.pathname.indexOf("outbox") == -1
              //     if $("#uploaded-placeholder").css("padding-top") != "7px"
              //         $("#uploaded-placeholder").css("padding-top", "7px")

              // if on action center clear out uploaded items placeholder
              if (window.current_btn.hasClass('single-upload')) {
                unique_id = window.current_btn.data('file_placeholder');
                console.log(unique_id);
                $(`#${unique_id}`).html("");
              }
              if (!(d.id in window.attachments)) {
                d3.select(`#${window.file_placeholder}`).append("div").attr("id", `attachment_${d.id}`).attr("class", "file-icon").on("click", function() {
                  return $.fileDownload(`/outbox/download/${d.id}/`);
                }).html(function(file_itm) {
                  return `<div class="outer-icon-container" onclick="deleteFile(event, ${d.id})">
    <div class="delete-icon-container" style="">
        <i class="delete-icon fa fa-minus-circle fa-sm" style=""></i>
    </div>
</div>
<div>
<div class="col-sm-3 file-img-container">
    <i class="fa fa-file f-img"></i>
</div>
<div class="col-sm-8 file-info-container">
    <div class="fname">${d.name}</div>
    <div class="fsize">${file_display[d.name]}</div>
</div>
<div>`;
                });
                return window.attachments[d.id] = {
                  name: d.name,
                  type: d.type,
                  // content: d.content
                  id: d.id,
                  size: file_display[d.name]
                };
              } else {
                return console.log("Already Uploaded");
              }
            });
          } else {
            // Handle errors here
            console.log('ERRORS: ' + data.error);
          }
        }
        $(".file-upload-btn.current-upload .add-file-icon").css("display", "inline");
        return $(".file-upload-btn.current-upload .loading-item-icon").css("display", "none");
      },
      error: function(jqXHR, textStatus, errorThrown) {
        // Handle errors here
        console.log('ERRORS: ' + textStatus);
        $(".file-upload-btn.current-upload .add-file-icon").css("display", "inline");
        $(".file-upload-btn.current-upload .loading-item-icon").css("display", "none");
        if (secure_upload) {
          return swal("Error", "Sorry, there was an error in uploading your file.", "error");
        }
      }
    });
  };

  window.reset_attachments = function() {
    if (window.current_btn) { // is not null
      window.current_btn.removeClass("current-upload");
    }
    window.current_btn = null;
    window.file_placeholder = "";
    window.attachments = {};
    return $("#f-upload-div").html('<input class="f-upload" type="file" name="file" multiple>');
  };

  $(document).ready(function() {
    // $.ajaxSetup beforeSend: (xhr, settings) ->
    //     xhr.setRequestHeader 'X-CSRFToken', csrf_token
    //     return

    //###########################
    // Attachment & Send emails #
    //###########################
    $(document).on('change', '#f-upload-div input[type=file].f-upload', prepareUpload);
    // $('input[type=file]').on 'change', prepareUpload
    $(document).on('click', '.file-upload-btn', function(e) {
      // determine if the same addition button clicked it

      if ($(this).hasClass("current-upload") === false) {
        // != window.current_btn

        // remove current attribute
        if (window.current_btn) { // is not null
          window.current_btn.removeClass("current-upload");
          $(".current_upload").removeClass("current-upload");
        }
        // wipe out attachments
        window.attachments = {};
        // WIPE OUT old?
        // $("##{window.file_placeholder} .file-icon").remove()

        // update the active button and clear previous attachments
        $(this).addClass("current-upload");
        window.current_btn = $(this);
        window.file_placeholder = $(this).data().file_placeholder;
        $("#f-upload-div").html('<input class="f-upload" type="file" name="file" multiple>');
      }
      e.preventDefault();
      $("#f-upload-div .f-upload")[0].click();
    });
  });

}).call(globalThis);
